import * as dueAtSigningActionCreators from '@makemydeal/dr-dash-store/actions/dueAtSigningActionCreators';
import * as dueAtSigningSelectors from '@makemydeal/dr-dash-store/selectors/dueAtSigningSelectors';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { useDispatch, useSelector } from 'react-redux';
import type { DasOverrides, DasPayment, DasToggleOpenPayload } from '@makemydeal/dr-dash-types';

export const useSummaryDueAtSigning = () => {
    const dispatch = useDispatch();
    const showSlideOut: boolean = useSelector(dueAtSigningSelectors.getIsSlideOutOpen);
    // Always derive the slide-out seed live from offer-redux so fees, taxes, payment (and any other DAS field)
    // stay in sync with the Breakdown screen and other modals on every open. (DE744697, DE748217)
    const defaultPayment = useSelector(dueAtSigningSelectors.getDasDefaultPayment);
    const defaultOverrides = useSelector(dueAtSigningSelectors.getDasDefaultOverrides);
    const liveDownPayment = useSelector(offerReduxSelectors.getDownPayment);
    const committedCashDueFromCustomer = useSelector(offerReduxSelectors.getCashDueFromCustomer);
    const isEquityAllocationOrderEnabled = useSelector(featureToggleSelectors.isEquityAllocationOrderEnabled);
    // Behind enableEquityAllocationOrder (US1833373): overlay the editable cash field and the latest
    // committed cash values on top of the live DAS seed so the slideout preview matches the summary
    // screen on open. When off, use the live seed unchanged.
    const overrides: DasOverrides = isEquityAllocationOrderEnabled
        ? { ...defaultOverrides, downPayment: liveDownPayment }
        : defaultOverrides;
    const payment: DasPayment = isEquityAllocationOrderEnabled
        ? { ...defaultPayment, cashDueFromCustomer: committedCashDueFromCustomer }
        : defaultPayment;

    const dasToggleOpenPayload: DasToggleOpenPayload = { overrides, payment };

    const toggleSlideOut = () => {
        dispatch(dueAtSigningActionCreators.toggleDasSlideOut(dasToggleOpenPayload));
    };

    return { showSlideOut, toggleSlideOut, overrides };
};
